import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'

import { Footer } from '../Home/Footer'
import { Header } from '../wallet/header/header'
import axios from '../utils/axios'
import useAuth from "../context/hook/useAuth"

//toast
import 'react-toastify/dist/ReactToastify.css'; // import first and after the toastify is work 
import { toast } from 'sonner'
import { MiniHeader } from '../Home/MiniHeader'
import site from "../utils/SiteSettings"
export const Withdrawal = () => {

    const {user} = useAuth()

    const [pair, setPair] = useState()

    const [chain, setChain] = useState([])

    const [second, setSecond] = useState(60)

    const [val, setVal] = useState()

    const [Otp, setOtp] = useState([])

    const [userOTP, setUserOTP] = useState([])

    const [verify, setVerify] = useState('Not verify')

    const [balance, setBalance] = useState(0)

    const [Fee, setFee] = useState([])

    const [address, setAddress] = useState([])

    const navigate = useNavigate()

    const getBalance = async (e) => {
        
        setPair(e.target.value)
        try {
            if(e.target.value === '') return toast.error(`Select a pair`,{position:'top-right'})
            await axios.put(`/particular/balance`,
                {
                    // id:'675819c6462acf37e7846b7a',
                    coin:e.target.value,
                    // id:auth.userId,
                    command: 'stop'
                },
                {
                    headers:{
                        "Content-Type": "application/json",
                        "Authorization":user
                    },
                    withCredentials:true,
                }
            ).then((res)=>{

                let data = JSON.parse(res.data)
                // console.log(data)
                setBalance(data.val)
                setFee(data.fee)
            }).catch(err=>{
                console.log(err)
            })
        } catch (error) {
            console.log(error)
        }
    }

    const handleOTP = async(e) =>{
        e.preventDefault()

        try {
            // eslint-disable-next-line
            if(pair == '') return toast.error(`Select a pair`,{position:'top-right'})
                // eslint-disable-next-line
            if(address == '') return toast.error(`Enter a destination address`,{position:'top-right'})

            if(Fee.withFee <= val){
                if(balance >= val ){
                    await axios.put("/withdrawal/otp",
                        {
                            total:val,
                            coin:pair,
                            add:address,
                            fee:Fee.withFee,
                            amount:val - Fee.withFee,
                            command: 'stop'
                        },
                        {
                            headers:{
                                "Content-Type": "application/json",
                                "Authorization":user
                            },
                            withCredentials:true,
                        },
                    ).then((res)=>{
                        const otp = res?.data.otp
                        // console.log(otp)
                        setOtp(otp)
                        setVerify("hi")
                        setSecond(60)
                        toast.success(<div>Verification Code has been sent to your email.<br/> Please enter the Verification Code</div>,{enableHtml: true,position:'top-right'})
                    })
                }else{
                    toast.error(`Insufficient balance`,{position:'top-right'})
                }
            }else{
                // toast.error(`Min value is ${fees.data.minWitusdt}`,{position:'top-right'})
                toast.error(`Min value is ${Fee.minWitusdt}`,{position:'top-right'})
            }
        } catch (error) {
            console.log(error)
        }
    }

    const onSubmit = async (e) => {
        try {
            // eslint-disable-next-line
            if(pair == '') return toast.error(`Select a pair`,{position:'top-right'})
            if(Otp === userOTP){
                // if(fees.data.minWitusdt <= val){
                if(Fee.withFee <= val){
                    if(balance >= val ){
                        await axios.post(
                            "/withdrawal",
                            {
                                amount:val > Fee.withFee ? val - Fee.withFee : 0 ,
                                type:"Crypto",
                                address,
                                inputVal:val,
                                asset:pair,
                                chain: pair === "USDT" ? chain : pair,
                            },{
                                headers:{
                                    "Content-Type": "application/json",
                                    "Authorization":user
                                },
                                withCredentials:true,
                            }
                        ).then(()=>{
                            setTimeout(()=>{
                                navigate('/wallet',{replace: true})
                            },1500)
                            toast.success("Withdrawal placed successfully",{position:'top-right'})
                            // console.log("done")
                        })
                    }else{
                        toast.error(`Insufficient balance`,{position:'top-right'})
                    }
                }else{
                    // toast.error(`Min value is ${fees.data.minWitusdt}`,{position:'top-right'})
                    toast.error(`Min value is ${Fee.withFee}`,{position:'top-right'})
                }
            }else{
                toast.error("Verification Code Verified Succesfully",{position:"top-right"})
            }
        } catch (error) {
            console.log(error)
        }
    }

  return (
    <div>
        <Header/>
        {/* <!-- service section start --> */}
        <section className="feature-section pb-0">
            <div className="container pb-md-5 pb-0">
                <div className="title-basic fs-sm">
                    {/* <!-- <h2 class="text-white">A Wide Range of
                        Functionality to Support Any Use Case</h2> --> */}
                </div>
                <ul className="tab-section mt-80">
                    <li><Link to={"/wallet"}>Wallet</Link></li>
                    <li><Link to={"/buy/token"}>Buy {site?.site?.siteName}</Link></li>
                    <li><Link to={"/deposit"}>Deposit</Link></li>
                    <li className="active"><Link to={""}>Withdraw</Link></li>
                    <li><Link to={"/setting"}>Settings</Link></li>
                    <li><MiniHeader /></li>
                </ul>
                <div className="row g-xxl-5 g-4 justify-content-center">
                <div className="col-lg-5">
                    <div className="buy-box">
                        <div className="buy-head">
                            <h3>Withdraw</h3>
                        </div>
                        {
                            verify === 'Not verify' ? (
                                <>
                                    <div className="deposit-area">
                                        <form action="">
                                            <div className="form-group">
                                                <label htmlFor="exampleFormControlSelect1">Select Crypto</label>
                                                <select value={pair} onChange={e=>getBalance(e)} className="custom-select" required="">
                                                    <option value="">Select Crypto</option>
                                                    <option value="BNB">BNB</option>
                                                    <option value={site?.site?.siteName}>{site?.site?.siteName}</option>
                                                    {/* <option value="ETH">ETH</option> */}
                                                    <option value="USDT">USDT</option>
                                                    <option value="TRX">TRX</option>
                                                </select>
                                            </div>
                                            {
                                                pair === "USDT" && (
                                                    <>
                                                        <div className="form-group">
                                                            <label htmlFor="exampleFormControlSelect1">Select Network</label>
                                                            {/* <select value={pair} onChange={e=> setPair(e.target.value)} className="custom-select" required> */}
                                                            <select value={chain} onChange={e=>setChain(e.target.value)} className="custom-select" required>
                                                                <option value="">Select Chain</option>
                                                                <option value="BNB">BNB</option>
                                                                {/* <option value="ETH">ETH</option> */}
                                                                {/* <option value="SOL">SOL</option> */}
                                                                <option value="TRX">TRX</option>
                                                                {/* <option value="XRP">XRP</option> */}
                                                            </select>
                                                            
                                                        </div>
                                                    </>
                                                )
                                            }
                                            {/* <div className="form-group">
                                                <label htmlFor="exampleFormControlSelect1">Select Crypto</label>
                                                <select value={pair} onChange={e=>getBalance(e)} className="custom-select" required="">
                                                    <option value="">Select Crypto</option>
                                                    <option value="BNB">BNB</option>
                                                    <option value="USDT">USDT</option>
                                                    <option value={site?.site?.siteName}>{site?.site?.siteName}</option>
                                                </select>
                                            </div> */}
                                            <div className="">
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Enter Address</label>
                                                <input value={address} onChange={e=>setAddress(e.target.value)} type="text" className="form-control" id="exampleFormControlInput1" placeholder="Enter Address"/>
                                            </div>
                                            <div className="">
                                                <label htmlFor="exampleFormControlInput1" className="form-label">Enter Amount</label>
                                                <input value={val} onChange={e=>setVal(e.target.value)} type="number" className="form-control" id="exampleFormControlInput1" placeholder="Enter Amount"/>
                                            </div>
                                            <div className="qtsYk">
                                                <div className="MhbUH" onClick={()=>setVal(balance&&balance)}>
                                                    <dl>
                                                        <dt className="lqZuR">
                                                        </dt>
                                                        <dd className="lqZuR">
                                                        <span className="-m6DU el-tooltip__trigger el-tooltip__trigger">Available</span>
                                                        <strong style={{"margin": "0px 4px"}}>{ balance ? balance.toFixed(6) :  "--" } {pair === "TOKEN" ? site?.site?.siteName : pair}</strong>
                                                        <svg fill="currentColor" style={{"width":" 16px", height: "16px"}}>
                                                            <use xlinkHref="#web-core-icon-transfer"></use>
                                                        </svg>
                                                        </dd>
                                                    </dl>
                                                {/* <!----> */}
                                                </div>
                                                <div className="_9truM">
                                                    <dl>
                                                        <dt>Fee</dt>
                                                        <dd>
                                                        <strong>
                                                            {
                                                                // eslint-disable-next-line
                                                                Fee.withFee != [] ? Fee.withFee  :  "--"
                                                            } {pair}</strong>
                                                        </dd>
                                                    </dl>
                                                    <dl>
                                                        <dt>{val >= Fee.minWitusdt && "To Receive"}</dt>
                                                        <dd>
                                                            <strong>{val >= Fee.minWitusdt ? `${val - Fee.withFee}` : `Min Withdrawal is ${Fee.minWitusdt}` } {pair} </strong>
                                                        </dd>
                                                    </dl>
                                                {/* <!----> */}
                                                </div>
                                                <button onClick={handleOTP} data-size="large" type="button" className="jRLsY SOUdU" style={{"width": "100%", marginTop: "24px"}}>
                                                    <span>
                                                        WITHDRAW {pair}
                                                    </span>
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </>
                            ) : (
                                <>
                                    <ChildComponent second={second} setSecond={setSecond} userOTP={userOTP} setUserOTP={setUserOTP} handleOTP={handleOTP} onSubmit={onSubmit}  />
                                </>
                            )
                        }

                    </div>
                </div>
                </div>
            </div>
        </section>
        {/* <!-- service section end --> */}

        <Footer/>

    </div>
  )
}


const ChildComponent = ({ second, setSecond, userOTP, setUserOTP, handleOTP, onSubmit }) => {

    useEffect(()=>{
        const interval = setInterval(()=>{
          
          if(second > 0 ){
            setSecond( second - 1)
          }
    
          if(second === 0){
            clearInterval(interval)
          }
        },1000)
    
        return ()=>{
          clearInterval(interval)
        }
        // eslint-disable-next-line
      },[second])
    return (
      <>
        <input type='number'  value={userOTP}   onChange={e=>setUserOTP(e.target.value)} required  className="form-control" id="exampleFormControlInput1" placeholder="Enter OTP "/>
        {
            second > 0 ? (
                <p>Time Remaining: {second < 10 ? `0${second}`: second} Secs</p>
            ) : (
                <p>Didn't receive the OTP?
                    {
                        second === 0 ? (
                            <button  className="log-btn" onClick={handleOTP}>Resend OTP</button>

                        ) : (
                            <p>Resend OTP</p>
                        )
                    }
                </p>
            )
        }
        <button onClick={onSubmit} data-size="large" type="submit" className="jRLsY SOUdU" style={{"width": "100%", "marginTop": "24px"}}> Withdraw </button>
    
      </>
    );
};